import usRpc from "@repo/protobuf/api/usRpc";
import FeatureStore from "@repo/utils-solid/FeatureStore";

import UsVariantByExperiment from "./experiments/UsaExperimentVariants";

const initialState = {
  variantByName: {} as Partial<UsVariantByExperiment>,
};

export const { Context, Provider, useExperiments } = FeatureStore.init(
  "Experiments",
  initialState,
  ([store, setStore], { attachAction, wrapActions }) => {
    const accessors = {
      variant: attachAction(
        <Name extends keyof UsVariantByExperiment>(name: Name) =>
          store.variantByName[name],
        (name) => actions.fetch(name)
      ),
    };

    const usa = {
      actions: {
        fetch(...names: (keyof UsVariantByExperiment)[]) {
          return usRpc.Experiments.getExperimentVariant({
            experimentNames: names,
          }).SUCCESS(({ experimentVariants }) => {
            setStore("variantByName", experimentVariants);
          });
        },
      },
    };
    const canada = {
      actions: {
        // TODO: Normalize experiment names and variants if we need
        fetch(...names: (keyof UsVariantByExperiment)[]) {
          setStore(
            "variantByName",
            Object.fromEntries(names.map((name) => [name, "control"] as const))
          );

          return Promise.resolve();
        },
      },
    };

    const actions = wrapActions(
      import.meta.env.API_ADAPTER === "canada" ? canada.actions : usa.actions
    );

    return { accessors, actions };
  }
);
